import { Component, HostListener, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router, NavigationEnd } from '@angular/router';
import { RouterModule } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ApidataService } from '../apidata.service';
import { FooterComponent } from '../footer/footer.component';
import { HeaderComponent } from '../header/header.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { MetaTagService } from '../meta-tag.service';
import { environment, GINConstants } from '../../environments/environments';
import { IconsFreeToolsComponent } from '../icons-free-tools/icons-free-tools.component';
declare var $: any;
@Component({
  selector: 'app-handbook',
  standalone: true,
  imports: [
    RouterModule,
    HeaderComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    FooterComponent,
    IconsFreeToolsComponent
  ],
  templateUrl: './handbook.component.html',
  styleUrl: './handbook.component.css',
})
export class HandbookComponent implements OnInit {
  public section = 'handbook';
  public doc_id = '';
  public homeText = '';
  public profile_id = '';
  public checkLogin = false;

  shouldShowButton: boolean = false;
  baseUrl: string = 'https://www.grammarin.com/handbook/';

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private apiservice: ApidataService,
    private renderer: Renderer2,
    private metaService: MetaTagService

  ) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
  }
  validcategory = [
    'grammar',
    'punctuation',
    'techniques',
    'mechanics',
    'style'
  ];
  valid_techniques = [
    "what-are-literary-devices",
    "what-is-irony",
    "what-is-a-motif",
    "what-is-oxymoron",
    "what-is-paradox",
    "what-does-exclamation-mark-mean",
    "what-is-personification",
    "what-is-suspense",
    "what-is-a-symbol",
    "what-is-verisimilitude",
    "what-is-vignette",
    "what-is-hyperbole",
    "what-are-onomatopoeia-words",
    "what-is-an-idiom",
    "what-are-collocations",
    "what-are-similes",
    "what-are-metaphors",
    "what-is-satire"
  ]
  validGrammar = [
    "what-are-modifiers",
    "what-are-adjectives",
    "what-are-determiners",
    "what-are-adverbs",
    "what-are-articles",
    "what-are-conjunctions",
    "what-are-interjections",
    "what-are-nouns",
    "what-are-prepositions",
    "what-are-pronouns",
    "what-are-verbs"
  ]
  validMechanics = [
    "what-is-abbreviation",
    "what-are-contractions",
    "what-are-spelling-rules",
    "what-is-capitalization",
    "what-are-compound-words"
  ]
  validPunctuation = [
    "what-are-apostrophes",
    "what-is-a-colon",
    "what-is-a-comma",
    "what-are-dashes",
    "what-is-an-ellipsis",
    "what-does-exclamation-mark-mean",
    "what-are-parentheses",
    "what-is-a-period",
    "how-to-do-upside-down-question-mark",
    "when-to-use-quotation-marks",
    "what-is-a-semicolon",
    "what-are-slashes",
    // "what-is-hyphen"
    "what-is-brackets"
  ]
  validStyle = [
    'what-is-passive-voice-construction', 'what-is-a-colon'
  ]
  activeTab: string = '';
  public docLink: string | null = null;
  public catagory: string | null = null;
  public subsection: string | null = null;
  public ngOnInit() {
    this.activatedRoute.url.subscribe((url) => {
      this.section = url[0]?.path || null;
    });
    this.activatedRoute.paramMap.subscribe(params => {
      this.catagory = params.get('catagory');
      if (this.catagory === null || this.catagory === undefined){
        if (this.section === 'handbook') {
          this.section = 'handbook';
          const url = `https://www.grammarin.com/handbook`;
          const title = 'Our Go-To Grammar Handbook for Success - GrammarIn';
          const description ='Master grammar with our comprehensive grammar handbook. Learn rules, tips, and examples to improve your writing and communication.';
          this.metaService.updateTags(title, description, url);
        } else {
          const sectionData = this.getSectionData(this.section);
          if (sectionData) {
            const url = `https://www.grammarin.com/${this.section}`;
            this.metaService.updateTags(sectionData.title, sectionData.description, url);
          }
        }
      } else {
        if (this.catagory != null || this.catagory != undefined) {
          this.section = this.catagory;
          if (!this.isValidSection(this.section)) {
            this.router.navigate(['/not-found']);
          } else {
            const sectionData = this.getSectionData(this.section);
            if (sectionData) {
              if (this.validcategory.includes(this.section)) {
                const url = `https://www.grammarin.com/handbook/${this.section}`;
                const img = `https://www.grammarin.com/assets/images/OG-Images/${this.section}.png`
                this.metaService.updateTags(sectionData.title, sectionData.description, url, img, `${this.section} Img`);
              } else {
                this.router.navigate(['/not-found']);
              }
            }
          }
        }

      }

    });
    this.checkLogin = this.apiservice.isLoggedIn();
    if (this.checkLogin) {
      this.profile_id = localStorage.getItem('profile_id');
    } else {
      this.profile_id = '1';
    }
    this.activeTab = 'q1';
  }
  toggleTab(tabId: string): void {
    if (this.activeTab === tabId) {
      this.activeTab = '';
    } else {
      this.activeTab = tabId;
    }
  }

  private isValidSection(section: string): boolean {
    return this.validcategory.includes(section) ||
      this.validStyle.includes(section) ||
      this.validPunctuation.includes(section) ||
      this.valid_techniques.includes(section) ||
      this.validMechanics.includes(section) ||
      this.validGrammar.includes(section) ||
      section === 'handbook';
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (window.pageYOffset > 200) {
      this.shouldShowButton = true;
    } else {
      this.shouldShowButton = false;
    }
  }
  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  private getSectionData(section: string) {
    const sectionMap = {
      'what-are-modifiers': {
        title: 'What Are Modifiers - Grammarin.com',
        description: 'Discover what modifiers are and how they enhance sentence meaning by describing or limiting words. Learn about adjective and adverb modifiers in grammar'
      },
      'what-are-adjectives': {
        title: 'What Are Adjectives - Grammarin.com',
        description: 'Learn what adjectives are and how they add color to language by describing nouns and pronouns. Understand types and examples of adjectives.'
      },
      'what-are-determiners': {
        title: ' What Are Determiners - Grammarin.com',
        description: 'Understand determiners and their role in grammar. Explore how words like "the," "a," and "some" clarify nouns in sentences.'
      },
      'what-are-adverbs': {
        title: ' What Are Adverbs - Grammarin.com',
        description: 'Discover the function of adverbs and how they modify verbs, adjectives, and other adverbs. Learn different types and examples of adverbs.'
      },
      'what-are-articles': {
        title: 'What Are Articles - Grammarin.com',
        description: 'Get to know articles in English grammar. Learn the differences between definite, indefinite, and zero articles, with examples.'
      },
      'what-are-conjunction': {
        title: 'What Are Conjunction - Grammarin.com',
        description: 'Learn about conjunctions and their role in connecting words, phrases, and clauses. Explore types and uses of conjunctions in sentences.'
      },
      'what-are-interjections': {
        title: 'What Are Interjections - Grammarin.com',
        description: 'Understand interjections and their unique function in expressing emotions. See examples of common interjections used in everyday speech.'
      },
      'what-are-nouns': {
        title: 'What Are Nouns - Grammarin.com',
        description: 'Discover nouns and their role as naming words. Learn about different types of nouns, including common, proper, abstract, and concrete nouns.'
      },
      'what-are-prepositions': {
        title: 'What Are Prepositions - Grammarin.com',
        description: 'Learn about prepositions and their role in showing relationships between words. See examples and types of prepositions in English.'
      },
      'what-are-pronouns': {
        title: 'What Are Pronouns - Grammarin.com',
        description: 'Explore pronouns and their role in replacing nouns. Understand types of pronouns, including personal, possessive, reflexive, and relative pronouns.'
      },
      'what-is-a-verb': {
        title: 'What Is a Verb - Grammarin.com',
        description: 'Understand verbs and their essential role in expressing action or state. Learn about types of verbs and their importance in sentences.'
      },
      'what-are-apostrophes': {
        title: 'What Are Apostrophes - Grammarin.com',
        description: 'Learn how to use apostrophes correctly in contractions and possessives. See examples and tips to avoid common mistakes.'
      },
      'what-is-a-colon': {
        title: 'What Is a Colon - Grammarin.com',
        description: 'Understand the colon and its uses in lists, explanations, and emphasis. Discover examples and best practices for using colons.'
      },
      'what-is-a-comma': {
        title: 'What Is a Comma - Grammarin.com',
        description: 'Discover the comma and its essential role in separating ideas. Learn common comma rules for clearer, more effective writing.'
      },
      'what-are-dashes': {
        title: 'What Are Dashes - Grammarin.com',
        description: 'Learn about dashes and their function in adding emphasis or interruptions. Explore different types of dashes and their uses.'
      },
      'what-is-an-ellipsis': {
        title: ' What Is an Ellipsis - Grammarin.com',
        description: 'Understand ellipses and their use in indicating omitted text or trailing thoughts. See examples and usage tips for ellipses.'
      },
      'what-does-exclamation-mark-mean': {
        title: 'What Is an Exclamation Mark - Grammarin.com',
        description: 'Discover exclamation marks and their role in showing strong emotion or emphasis. Learn when and how to use them effectively.'
      },
      'what-is-brackets': {
        title: 'What Is Brackets - Grammarin.com',
        description: 'What are brackets in grammar? Understand their purpose, types, and examples to improve your writing skills.'
      },
      'what-is-a-period': {
        title: 'What Is a Period - Grammarin.com',
        description: 'Discover the period and its essential role in ending sentences. See examples of when to use periods for clear writing.'
      },
      'how-to-do-upside-down-question-mark': {
        title: 'What Is a Question Mark - Grammarin.com',
        description: 'Understand question marks and their role in indicating direct questions. Learn correct placement and common uses of question marks.'
      },
      'when-to-use-quotation-marks': {
        title: 'What Are Quotation Marks - Grammarin.com',
        description: 'Explore quotation marks and their use in dialogue, titles, and emphasizing words. See examples and rules for proper punctuation.'
      },
      'what-is-a-semicolon': {
        title: 'What Is a Semicolon - Grammarin.com',
        description: 'Learn about semicolons and their role in connecting closely related ideas. Understand when to use semicolons for clarity.'
      },
      'what-are-slashes': {
        title: 'What Are Slashes - Grammarin.com',
        description: 'Discover slashes and their versatile use in indicating choices, line breaks, and abbreviations. Learn tips for proper usage.'
      },
      'what-is-abbreviation': {
        title: 'What Is an Abbreviation - Grammarin.com',
        description: 'Learn about abbreviations and their role in shortening words or phrases. See common examples and tips for using them effectively.'
      },
      'what-are-contractions': {
        title: 'What Are Contractions - Grammarin.com',
        description: 'Understand contractions and their function in combining words. Learn common contractions and how to use them correctly in writing.'
      },
      'what-are-spelling-rules': {
        title: 'What Are Spelling Rules - Grammarin.com',
        description: 'Discover essential spelling rules that simplify English spelling. Learn tips and tricks for improving your spelling skills.'
      },
      'what-is-capitalization': {
        title: 'What is Capitalization - Grammarin.com',
        description: 'Learn the rules of capitalization and when to capitalize words in English. See examples for titles, sentences, and names.'
      },
      'what-are-compound-words': {
        title: 'What Are Compound Words - Grammarin.com',
        description: 'Understand compound words and how they combine words to create new meanings. Learn types of compounds and common examples.'
      },
      'what-are-literary-devices': {
        title: 'What Are Literary Devices - Grammarin.com',
        description: 'Discover literary devices that enhance writing, such as metaphor, symbolism, and irony. See examples of devices used in literature.'
      },
      'what-is-irony': {
        title: 'What Is Irony - Grammarin.com',
        description: 'Learn about irony and its role in conveying meaning with contrast. Understand different types of irony, including verbal, situational, and dramatic.'
      },
      'what-is-a-motif': {
        title: 'What Is a Motif - Grammarin.com',
        description: 'Discover motifs in literature and their role in reinforcing themes. Learn examples of motifs used in stories and narratives.'
      },
      'what-is-oxymoron': {
        title: 'What Is Oxymoron - Grammarin.com',
        description: 'Understand oxymorons and their effect in creating unique, contrasting phrases. Explore examples of oxymorons in everyday language.'
      },
      'what-is-paradox': {
        title: 'What Is Paradox - Grammarin.com',
        description: 'Learn about paradoxes and how they reveal deeper truths. See examples of paradoxes and their impact in literature and speech.'
      },
      'what-is-personification': {
        title: 'What Is Personification - Grammarin.com',
        description: 'Discover personification and its role in bringing life to non-human elements. See examples and uses of personification in writing.'
      },
      'what-is-satire': {
        title: 'What Is Satire - Grammarin.com',
        description: 'Learn about satire and its use in humor and social criticism. Discover examples of satire and its impact on society.'
      },
      'what-is-suspense': {
        title: 'What Is Suspense - Grammarin.com',
        description: 'Understand suspense and its role in keeping readers engaged. Learn how suspense is created in literature and film.'
      },
      'what-is-a-symbol': {
        title: 'What Is a Symbol - Grammarin.com',
        description: 'Discover symbols and their importance in representing ideas. Learn about common symbols used in literature and art.'
      },
      'what-is-verisimilitude': {
        title: 'What Is Verisimilitude - Grammarin.com',
        description: 'Understand verisimilitude and how it brings realism to fiction. Learn examples of how verisimilitude is used in stories.'
      },
      'what-is-vignette': {
        title: 'What Is Vignette - Grammarin.com',
        description: 'Learn about vignettes and their role in capturing brief, descriptive scenes. See examples of vignettes in literature.'
      },
      'what-is-hyperbole': {
        title: 'What Is Hyperbole - Grammarin.com',
        description: 'Discover hyperbole and its effect in adding emphasis through exaggeration. Learn examples and uses of hyperbole in writing.'
      },
      'what-are-onomatopoeia-words': {
        title: 'What Are Onomatopoeia Words - Grammarin.com',
        description: 'Explore onomatopoeia and how words mimic sounds. Discover examples of onomatopoeic words in English.'
      },
      'what-is-an-idiom': {
        title: 'What Is an Idiom - Grammarin.com',
        description: 'Understand idioms and their meaning beyond literal language. See common idioms and their meanings in English.'
      },
      'what-are-collocations': {
        title: 'What Are Collocations - Grammarin.com',
        description: 'Discover collocations and their role in creating natural-sounding English phrases. See examples of common English collocations.'
      },
      'what-is-passive-voice-construction': {
        title: 'What Is Passive Voice Construction - Grammarin.com',
        description: 'Learn about passive voice and how it shifts focus in sentences. See examples and understand when to use passive voice.'
      },
      'what-is-parallelism': {
        title: 'What Is Parallelism - Grammarin.com',
        description: 'Understand parallelism and its importance in balancing sentence structure. Learn examples and tips for effective parallelism.'
      },
      'what-are-similes': {
        title: 'What Are Similes - Grammarin.com',
        description: 'Discover what similes are, how to use them in writing to make comparisons, and explore examples to add creativity to your language.'
      },
      'what-are-metaphors': {
        title: 'What Are Metaphors - Grammarin.com',
        description: 'Understand the meaning of metaphors, see how they differ from similes, and learn to use them to add depth and imagery to your writing.'
      },
      'what-are-parentheses': {
        title: 'What Are Parentheses - Grammarin.com',
        description: 'Learn the purpose of parentheses in writing, how they are used to add clarity, and tips for using them effectively in sentences.'
      },
      'grammar': {
        title: 'Learn Grammar Online: Free Resources and Guides',
        description: 'Your ultimate resource for mastering English grammar. Clear examples, tips, and tricks to improve your communication.'
      },
      'techniques': {
        title: 'Techniques: Innovative Solutions for Every Writing Challenge',
        description: 'Master the art of writing success with proven techniques across various fields. Explore innovative solutions today!'
      },
      'mechanics': {
        title: 'Mechanics: Simplifying Complex Writing Approaches',
        description: 'Learn about the fundamentals of mechanics in writing and their real-world solutions across the world wide.'
      },
      'style': {
        title: 'Unlock Your Unique Writing Style: Tips & Techniques',
        description: 'Discover how to develop and refine your unique writing style with expert tips and techniques.'
      },
      'punctuation': {
        title: 'Punctuation Basics: Your Guide to Better Writing',
        description: 'Master punctuation with our simple guide. Improve your writing clarity and avoid common mistakes with key punctuation tips.'
      },
      'default': {
        title: 'Our Go-To Grammar Handbook for Success - GrammarIn',
        description: 'Master grammar with our comprehensive grammar handbook. Learn rules, tips, and examples to improve your writing and communication.'

      }
    }
    return sectionMap[section] || sectionMap['default'];
  }

  Grammar1 = [
    { name: 'Modifiers', route: '/what-are-modifiers' },
    { name: 'Adjectives', route: '/what-are-adjectives' },
    { name: 'Determiners', route: '/what-are-determiners' },
    { name: 'Adverbs', route: '/what-are-adverbs' },
    { name: 'Articles', route: '/what-are-articles' },
    { name: 'Conjunctions', route: '/what-are-conjunction' }
  ];
  Grammar2 = [
    { name: 'Interjections', route: '/what-are-interjections' },
    { name: 'Nouns', route: '/what-are-nouns' },
    { name: 'Prepositions', route: '/what-are-prepositions' },
    { name: 'Pronouns', route: '/what-are-pronouns' },
    { name: 'Verbs', route: '/what-is-a-verb' }
  ];
  Punctuation1 = [
    { name: 'Apostrophe', route: '/what-are-apostrophes' },
    { name: 'Colon', route: '/what-is-a-colon' },
    { name: 'Comma', route: '/what-is-a-comma' },
    { name: 'Dash', route: '/what-are-dashes' },
    { name: 'Ellipsis', route: '/what-is-an-ellipsis' },
    { name: 'Exclamation Mark', route: '/what-does-exclamation-mark-mean' }
  ];
  Punctuation2 = [
    { name: 'Parentheses', route: '/what-are-parentheses' },
    { name: 'Period', route: '/what-is-a-period' },
    { name: 'Question Mark', route: '/how-to-do-upside-down-question-mark' },
    { name: 'Quotation Marks', route: '/when-to-use-quotation-marks'  },
    { name: 'Semicolon', route: '/what-is-a-semicolon' },
    { name: 'Slashes', route: '/what-are-slashes' }
  ];
  Punctuation3 = [
    { name: 'Brackets', route: '/what-is-brackets' }
  ];
  Mechanics1 = [
    { name: 'Abbreviations', route: '/what-is-abbreviation' },
    { name: 'Contractions', route: '/what-are-contractions' },
    { name: 'Spelling Rules', route: '/what-are-spelling-rules' },
    { name: 'Capitalization', route: '/what-is-capitalization' },
    { name: 'Compound Words', route: '/what-are-compound-words' }
  ];
  Style = [
    { name: 'Passive Voice', route: '/what-is-passive-voice-construction' },
    { name: 'Parallelism', route: '/what-is-parallelism' }
  ];
  Techniques1 = [
    { name: 'Literary Devices', route: '/what-are-literary-devices' },
    { name: 'Irony', route: '/what-is-irony' },
    { name: 'Motif', route: '/what-is-a-motif' },
    { name: 'Oxymoron', route: '/what-is-oxymoron' },
    { name: 'Paradox', route: '/what-is-paradox' },
    { name: 'Personification', route: '/what-is-personification' }
  ];

  Techniques2 = [
      { name: 'Suspense', route: '/what-is-suspense' },
      { name: 'Symbol', route: '/what-is-a-symbol' },
      { name: 'Verisimilitude', route: '/what-is-verisimilitude' },
      { name: 'Vignette', route: '/what-is-vignette' },
      { name: 'Hyperbole', route: '/what-is-hyperbole' },
      { name: 'Onomatopoeia Words', route: '/what-are-onomatopoeia-words' }
    ];

    Techniques3 = [
        { name: 'Idiom', route: '/what-is-an-idiom' },
        { name: 'Collocations', route: '/what-are-collocations' },
        { name: 'Similes', route: '/what-are-similes' },
        { name: 'Metaphors', route: '/what-are-metaphors' },
        { name: 'Satire', route: '/what-is-satire' }
      ];
}
